<template>
    <div class="kit-data-statistics-index">
        <el-row style="padding-bottom:10px">
            <el-col :span="24">
                <a
                    :href="exportHref"
                    target="_blank"
                    download="导出"
                >
                    <el-button
                        type="primary"
                        size="medium"
                    >导出
                    </el-button>
                </a>
                <el-input
                    class="search-input search-input--right"
                    size="medium"
                    placeholder="请输入套件名称"
                    icon="el-icon-search"
                    clearable
                    v-model="form.name"
                    @change="filterSearch"
                >
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                    ></el-button>
                </el-input>
            </el-col>
        </el-row>

        <div class="tabeWrapper">
            <el-table
                stripe
                border
                fit
                highlight-current-row
                style="width: 100%"
                :height="windowHeight - 215"
                :data="dataList"
            >
                <el-table-column
                    label="序号"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="套件名称"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="套件类型"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.suiteType | filterSuiteType}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="适用环境"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.suiteEnvironment | filterSuiteEnvironment}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="所属分类"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.suiteGroups | filterSuiteGroups}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="安装学校数"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.schoolCount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                >
                    <template slot-scope="scope">
                        <el-button
                            size="small"
                            type="text"
                            @click="gotoDetail(scope.row)"
                        >查看详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page.sync="pagination.pageNo"
                :page-size="pagination.pageSize"
                :page-sizes="pagination.pageSizes"
                :total="pagination.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    /* utils */
    import mixin from "@/mixins/windowResize";

    /* components */

    /* api */
    import {querySuiteList} from "@/api/kitDataStatistics";
    import {getExportUrl} from '@/utils/utils';

    export default {
        mixins: [mixin],
        components: {},
        filters: {
            filterSuiteEnvironment(val) {
                if (val == 1) {
                    return "通用";
                } else if (val == 2) {
                    return "微校+";
                } else if (val == 3) {
                    return "成长乐园";
                }
            },
            filterSuiteType(val) {
                if (val == 1) {
                    return "应用套件";
                } else if (val == 2) {
                    return "通讯录套件";
                } else if (val == 3) {
                    return "普通应用";
                } else if (val == 4) {
                    return "家长通讯录";
                } else if (val == 6) {
                    return "家校应用";
                }
            },
            filterSuiteGroups(val) {
                if (val == 1) {
                    return "通讯录";
                } else if (val == 2) {
                    return "基础套件";
                } else if (val == 3) {
                    return "独立应用";
                } else if (val == 4) {
                    return "行业应用";
                }
            },
        },
        computed: {
            exportHref() {

                return getExportUrl('/statisticsWY/exportSuiteList', {
                    name: this.form.name,
                }, global.command === "production"
                    ? "https://wyms.weixiaojia.cn/wyms"
                    : "https://wyms.weixiaojia.net/wyms");
            },
        },
        data() {
            return {
                // 是否正在加载数据 { Boolean }
                tabLoading: false,
                // 表格数据 { Array }
                dataList: [],
                // 分页
                pagination: {
                    pageNo: 1,
                    pageSize: 20,
                    pageSizes: [10, 20, 30, 50],
                    total: 0,
                },
                form: {
                    name: "",
                },
            };
        },
        created() {
            this.querySuiteList();
        },
        methods: {
            // 查询套件列表
            querySuiteList() {
                querySuiteList({
                    name: this.form.name,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                }).then((data) => {
                    let {dataList, pagination} = data;
                    this.dataList = [...dataList];
                    this.pagination.total = pagination.total;
                });
            },

            // 检索条件改变
            filterSearch() {
                this.pagination.pageNo = 1;
                this.querySuiteList();
            },
            // 分页 - pageSize 改变
            handleSizeChange(pageSize) {
                this.pagination.pageSize = pageSize;
                this.querySuiteList();
            },
            // 分页 - currentPage 改变
            handleCurrentChange(pageNo) {
                this.pagination.pageNo = pageNo;
                this.querySuiteList();
            },

            // 详情页
            gotoDetail(item) {
                this.$router.push({
                    path: "detail",
                    query: {
                        suiteId: item.suiteId,
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .kit-data-statistics-index {
        padding: 12px;

        * {
            box-sizing: border-box;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/kitDataStatistics/index.vue